<template>
  <div>
      <fieldset>
          <div class="row">
              <legend>Shipping Information</legend>
          </div>
          <div class="row">
              <labeled-input label="Address Line 1 (no P.O. boxes please) *" name="Address line 1" v-model='sampleobject.addressLine1'></labeled-input>
          </div>
          <div class="row">
              <labeled-input validation="" label="Address Line 2" name="Address line 2" v-model='sampleobject.addressLine2'></labeled-input>
          </div>
          <div class="row">
              <div class="medium-6 columns lp">
                  <labeled-input label="City *" name="City" v-model='sampleobject.city'></labeled-input>
              </div>
              <div class="medium-3 columns mp">
                  <div :class="{'error': errors.has('State / Region') }">
                      <label for="region">State / Region *</label>
                      <input id="region" type="text" v-validate="'required|min:2'" name="State / Region" class="full-txt" maxlength="2" placeholder="" v-model='sampleobject.region'>
                      <p class="error" v-if="errors.has('State / Region')">{{ errors.first('State / Region') }}</p>
                  </div>
              </div>
              <div class="medium-3 columns rp">
                  <labeled-input validation="required|regex:^\d{5}(?:[-\s]\d{4})?$" label="Postal Code *" name="Postal Code" v-model='sampleobject.postalCode'></labeled-input>
              </div>
          </div>
          <div class="row">
            <div class="medium-6 columns lp">
                <div :class="{'error': errors.has('Mobile Phone') || errorMessage }">
                    <label for="mobilephone">
                        Personal Cell Number
                        *
                    </label>
                    <div class="input-container">
                        <input id="mobilephone" @blur="formatShippingMobilePhoneNumber()" type="text" v-validate="'required'" name="Mobile Phone" class="full-txt number" placeholder="" v-model='sampleobject.mobilePhone'>
                    </div>
                    <p class="error" v-if="errors.has('Mobile Phone') || errorMessage">{{ errors.first('Mobile Phone') || errorMessage }}</p>
                </div>
            </div>
            <div class="medium-6 columns lp">
            </div>
          </div>
          <div class="row">
              <div class="medium-8 columns lp">
                  <labeled-input validation="required|email" label="Email *" name="Email" autocomplete="on" v-model='sampleobject.email' :readonly="true" @change="validateEmail"></labeled-input>
                  <small class="duplicate-error" v-if="hasNoSupplier" v-html="supplierNotFoundMessage"></small>
                  <small class="duplicate-error" v-if="hasInvalidGeoInfo" v-html="invalidGeoInfo"></small>
                  <small class="duplicate-error" v-if="hasInvalidEmail" v-html="invalidEmail"></small>
                  <small class="duplicate-error" v-if="hasDuplicateOrder1" v-html="duplicateOrderMessage1"></small>
                  <small class="duplicate-error" v-if="hasDuplicateOrder2" v-html="duplicateOrderMessage2"></small>
                  <small class="duplicate-error" v-if="hasDuplicateOrder3" v-html="duplicateOrderMessage3"></small>
              </div>
          </div>
      </fieldset>

      <!-- Address Override Modal -->
      <div v-if="showOverrideModal" class="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="override-title">
        <div class="modal-container">
          <h3>Address Validation Warning</h3>

          <div class="modal-body">
            <!-- dynamic address error message -->
            <p class="error-text" v-if="addressErrorMessage">{{ addressErrorMessage }}</p>

            <p>
              Our system was unable to fully validate the entered address.
              Please review the details carefully and ensure that your address
              is complete and accurate.
            </p>

            <p>
              Incorrect addresses may result in delivery delays or failed
              shipments. By proceeding, you acknowledge that you are confirming
              the accuracy of the provided address.
            </p>
          </div>

          <div class="modal-actions">
            <button
              type="button"
              class="button secondary"
              @click="proceedAnyway"
            >
              Proceed Anyway
            </button>
            <button
              type="button"
              class="button primary"
              @click="editAddress"
            >
              Edit Address
            </button>
          </div>
        </div>
      </div>

      <!-- Suggested Address Modal -->
      <div
        v-if="showSuggestionModal && suggestedAddress"
        class="modal-overlay"
        role="dialog"
        aria-modal="true"
      >
        <div class="modal-container">
          <h3>Verify your address</h3>

          <div class="modal-body">
            <p>
              Please review the options below and select the address you would like to use.
              To avoid delays, please use the recommended address.
            </p>

            <div class="address-compare">
              <div>
                <strong>Original address:</strong>
                <p>{{ formattedOriginalAddress }}</p>
              </div>
              <div>
                <strong>Recommended address:</strong>
                <p>{{ suggestedAddress.formatted }}</p>
              </div>
            </div>
          </div>

          <div class="modal-actions">
            <button
              type="button"
              class="button secondary"
              @click="dismissSuggestedAddress"
            >
              Use Original Address
            </button>

            <button
              type="button"
              class="button primary"
              @click="applySuggestedAddress"
            >
              Use Recommended Address
            </button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import auth from "@/api/auth.js";
import LabeledInput from "@/components/shared/LabeledInput";

export default {
props: ["sampleobject"],
inject: ["$validator"],
components: { LabeledInput },
data() {
  return {
    timeOutTimer: null,
    hasDuplicateOrder1: false,
    hasDuplicateOrder2: false,
    hasDuplicateOrder3: false,
    hasInvalidGeoInfo: false,
    hasInvalidEmail: false,
   duplicateOrderMessage1: `Our records indicate that you have already ordered a <strong>Transitions<sup>&reg;</sup> GEN S<sup>&trade;</sup></strong> product. 
      Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of Transitions<sup>&reg;</sup> GEN S<sup>&trade;</sup> lenses. 
      For more details, please contact NPLE support at NPLEsupport@essilorusa.com.`,
    duplicateOrderMessage2: `Essilor has determined that it is reasonable to offer all eligible employees professional eyecare practices with only limited evaluation products. For more details, please contact your sales representative.`,
    duplicateOrderMessage3: `Our records indicate that you have already ordered this particular combination of Essilor products. 
Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of lenses with these specific attributes. 
For more details. For more details, please contact NPLE support at NPLEsupport@essilorusa.com.`,
    invalidGeoInfo: ` Invalid Geo information. `,
    invalidEmail: `Please enter your employee email address. `,
    errorMessage: '',
    showInfo: false,
    supplierNotFoundMessage: 'Missing lab to process.',
    hasNoSupplier: false,
    showOverrideModal: false,
    showSuggestionModal: false,
    addressErrorMessage: '',
    suggestedAddress: null,
    formattedOriginalAddress: '',
    addressOverrideSelected: false,
    errorResponseData: '',
  };
},
computed: {
  duplicateOrderHasUpdate() {
    const { firstName, lastName, email, couponCode, mobilePhone, treatment, design, photochromic, material } = this.sampleobject;
    return {
      firstName,
      lastName,
      email,
      couponCode,
      mobilePhone,
      design,
      material,
      photochromic,
      treatment,
    };
  }
},
methods: {
  validate() {
    this.$validator.validateAll();
  },
  formatShippingPhoneNumber() {
    this.sampleobject.phone = this.formatPhoneNumber(this.sampleobject.phone);
  },
  formatShippingMobilePhoneNumber() {
    this.sampleobject.mobilePhone = this.formatPhoneNumber(this.sampleobject.mobilePhone, 'mobilePhone');
  },
  formatPhoneNumber(args, type = 'telephone') {
    var s2 = ("" + args).replace(/\D/g, "");
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (type === 'mobilePhone' && !m) {
      this.errorMessage = "The Mobile Phone field must be 10 digits.";
      return args;
    }
    else this.errorMessage = ""
    return !m ? null : m[1] + "-" + m[2] + "-" + m[3];
  },
  checkDuplicateOrder() {
    const {
      firstName,
      lastName,
      email,
      couponCode,
      mobilePhone,
      design,
      material,
      photochromic,
      treatment,
    } = this.sampleobject;
    if (!firstName || !lastName || !email || !mobilePhone || !photochromic || !material || !design) return;
    axios
      .get(`/order?firstname=${firstName}&lastname=${lastName}&email=${email}&coupon=${couponCode}&mobilephone=${mobilePhone}&treatment=${treatment}&design=${design}&material=${material}&photochromic=${photochromic}`)
      .then((response) => {
        const responseList = response.data.split('|')
        const duplicateOrderResponse = responseList[0]
        if (duplicateOrderResponse.toLowerCase() === "ok") {
          this.hasDuplicateOrder1 = false;
          this.hasDuplicateOrder2 = false;
          this.hasDuplicateOrder3 = false;
          this.$emit('hasDuplicateOrder1', false)
          this.$emit('hasDuplicateOrder2', false)
          this.$emit('hasDuplicateOrder3', false)
        }
      })
      .catch((error) => {
        const errorList = error.response.data.split('|')
        const duplicateOrderResponse = errorList[0]
        const legacyOrderResponse = errorList[1]
        
        if (duplicateOrderResponse.toLowerCase() === "duplicate detected" && legacyOrderResponse.toLowerCase() === "false") {
          this.hasDuplicateOrder1 = true;
          this.$emit('hasDuplicateOrder1', true)
        }
        if (duplicateOrderResponse.toLowerCase() === "duplicate detected" && legacyOrderResponse.toLowerCase() === "true") {
          this.hasDuplicateOrder2 = true;
          this.hasDuplicateOrder3 = false;
          this.$emit('hasDuplicateOrder2', true)
          this.$emit('hasDuplicateOrder3', false)
        }
        if (duplicateOrderResponse.toLowerCase() === "already ordered" && legacyOrderResponse.toLowerCase() === "true") {
          this.hasDuplicateOrder3 = true;
          this.hasDuplicateOrder2 = false;
          this.$emit('hasDuplicateOrder3', true)
          this.$emit('hasDuplicateOrder2', false)
        }
        if (duplicateOrderResponse.toLowerCase() === "geo tag id not found") {
          this.hasInvalidGeoInfo = true;
          this.$emit('hasInvalidGeoInfo', true)
        }
        if (duplicateOrderResponse.toLowerCase() === "supplier not found") {
          this.hasNoSupplier = true;
          this.$emit('hasNoSupplier', true)
        }
      });
  },
  validateEmail(shippingEmail) {
    const emailFiltered = (shippingEmail || "").toLowerCase().trim();
    // Check if email is undefined or null
    if (emailFiltered == null) {
      return;
    }

    if (emailFiltered.includes("@essilorusa.com") || emailFiltered.includes("@essilorluxottica.com") || emailFiltered.includes("@essilorluxottica.id") || emailFiltered.includes("@midlandoptical.com") || 
        emailFiltered.includes("@essilor.com") || emailFiltered.includes("@luxottica.com") || emailFiltered.includes("@us.luxottica.com")) {
            this.hasInvalidEmail = false;
          } else {
            this.hasInvalidEmail = true;
          }
          this.$emit('hasInvalidEmail', this.hasInvalidEmail);
  },
  proceedAnyway() {
    // Logic to proceed with the original address
    this.showOverrideModal = false;
  },
  editAddress() {
    this.showOverrideModal = false;

    if (this.sampleobject) {
      this.sampleobject.UseManualAddress = false;
    }

    this.$emit("addressValidationError", false);
  },
  dismissSuggestedAddress() {
    this.suggestedAddress = null;
    this.showSuggestionModal = false;

    if (this.sampleobject) {
      this.sampleobject.UseManualAddress = false;
    }

    this.$emit("addressSuggestionApplied", false);
  },
  applySuggestedAddress() {
    if (!this.suggestedAddress) return;
    this.sampleobject.addressLine1 = this.suggestedAddress.AddressLine1;
    this.sampleobject.addressLine2 = (this.suggestedAddress.AddressLine2 || "").trim() || null;
    this.sampleobject.city = this.suggestedAddress.City;
    this.sampleobject.region = this.suggestedAddress.State;
    this.sampleobject.postalCode = this.suggestedAddress.PostalCode;
    this.showSuggestionModal = false;
    this.suggestedAddress = null;
    this.$emit("addressSuggestionApplied", true);
  },
  checkAddress() {
    const { addressLine1, addressLine2, city, region, postalCode, couponCode } =
      this.sampleobject;

    if (!addressLine1 || !city || !region || !postalCode || !couponCode) {
      return;
    }

    const payload = {
      address1: addressLine1,
      address2: addressLine2 || "",
      city: city,
      state: region,
      postalCode: postalCode,
    };

    axios
      .post(`/order/ValidateAddress?couponCode=${couponCode}`, payload)
      .then((response) => {
        const { AddressLine1, AddressLine2, City, State, PostalCode } =
          response.data;
        this.suggestedAddress = {
          AddressLine1,
          AddressLine2,
          City,
          State,
          PostalCode,
          formatted: `${AddressLine1} ${AddressLine2 || ""}, ${City}, ${State} ${PostalCode}`,
        };

        const different =
          this.sampleobject.addressLine1 !== AddressLine1 ||
          this.sampleobject.addressLine2 !== AddressLine2 ||
          this.sampleobject.city !== City ||
          this.sampleobject.region !== State ||
          this.sampleobject.postalCode !== PostalCode;

        if (different) {
          this.showSuggestionModal = true;
        }

        this.$emit("addressValidationError", false);
      })
      .catch((error) => {
        const message =
          error.response && error.response.data
            ? error.response.data
            : "An error occurred while validating the address.";

        this.addressErrorMessage = message;
        this.showOverrideModal = true;
        this.$emit("addressValidationError", true);
      });
  },
  clearAddressErrors() {
    if (this.errorResponseData) {
      this.errorResponseData = "";
    }
    this.$emit("addressValidationError", false);
  },
  checkAddressFields() {
    const { addressLine1, city, region, postalCode, couponCode } = this.sampleobject;
    if (
      !!addressLine1 &&
      !!city &&
      !!region &&
      !!postalCode &&
      !!couponCode
    ) {
      clearTimeout(this.timeOutTimer);
      this.timeOutTimer = setTimeout(() => {
        this.checkAddress();
      }, 1000);
    }
  },
  editAddress() {
    this.showOverrideModal = false;
    if (this.sampleobject) {
      this.sampleobject.UseManualAddress = false;
    }
    this.$emit("addressValidationError", false);
  },
  proceedAnyway() {
    this.addressOverrideSelected = true;
    if (this.sampleobject) {
      this.sampleobject.addressOverride = true;
      this.sampleobject.UseManualAddress = true;
    }
    this.showOverrideModal = false;
    this.$emit("addressOverrideSelected", true);
    this.$emit("addressValidationError", false);
  }
},
created() {
  this.formatShippingPhoneNumber();
  if (this.sampleobject.mobilePhone) {
    this.formatShippingMobilePhoneNumber();
  }
  auth.getUser()
  .then(user => {
    console.log("Authenticated user info", user);

    const email =
      user.emailAddress != null
        ? user.emailAddress
        : (user.email != null ? user.email : "");

    this.sampleobject.email = email.toLowerCase().trim();
  })
  .catch(err => {
    console.error("Failed to get authenticated user", err);
  });
},
watch: {
  duplicateOrderHasUpdate: {
    handler: function(data) {
      const { firstName, lastName, email, mobilePhone, photochromic, design, material } = data;
      if (!!firstName && !!lastName && !!email && !!mobilePhone && !!photochromic && !!design && !!material) {
        clearTimeout(this.timeOutTimer);
        this.timeOutTimer = setTimeout(() => {
          this.checkDuplicateOrder();
        }, 1000);
      }
    },
    deep: true
  },
  'sampleobject.email': {
    handler: function(shippingEmail) {
      this.validateEmail(shippingEmail);
    },
  immediate: true // Trigger the handler immediately when the component is created
  },
  'sampleobject.addressLine1': {
    handler: function() {
      this.clearAddressErrors();
      this.checkAddressFields();
    }
  },
  'sampleobject.city': {
    handler: function() {
      this.clearAddressErrors();
      this.checkAddressFields();
    }
  },
  'sampleobject.region': {
    handler: function() {
      this.clearAddressErrors();
      this.checkAddressFields();
    }
  },
  'sampleobject.postalCode': {
    handler: function() {
      this.clearAddressErrors();
      this.checkAddressFields();
    }
  },
  'sampleobject.addressLine2': {
    handler: function() {
      this.clearAddressErrors();
      this.checkAddressFields();
    }
  },
  'sampleobject.couponCode': {
    handler: function(couponCode) {
      this.clearAddressErrors();
      this.checkAddressFields();
    }
  },
  'sampleobject.mobilePhone': {
    handler: function() {
      this.clearAddressErrors();
      this.checkAddressFields();
    }
  },
  'sampleobject.UseManualAddress': {
    handler: function() {
      this.clearAddressErrors();
      this.checkAddressFields();
    }
  }
 }
};
</script>
<style>
.duplicate-error {
  color: red;
}
.note {
color: red;
font-weight: bold;
font-size: 11px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-container {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
}
.modal-body {
  margin-bottom: 20px;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.error-text {
  color: red;
  font-weight: bold;
}
</style>
